<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="fund-settlement">
      <Title jpn="Description basée sur la loi sur les services de paiement" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Nom de la société exploitante</span>
            <span class="text">Xéro Place Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">personne représentative</span>
            <span class="text">Yuki Narita</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Adresse d'enregistrement de la société/adresse du bureau commercial</span>
            <span class="text">〒330-0854</span>
            <span class="text">1-195-1 Sakuragi-cho, Omiya-ku, Saitama-shi,</span>
            <span class="text">Saitama  Omiya Soramichi KOZ 4e étage</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Limite/durée de propriété des pièces (devise sur ce site)</span>
            <span class="text">Il n’y a pas de limite supérieure pour les pièces.</span>
            <span class="text">Toutefois, si 6 mois (jour inclus) se sont écoulés depuis la dernière utilisation des Coins sans les utiliser après l'achat ou l'échange des Coins, nous pouvons supprimer votre compte sans vous en informer au préalable.</span>
            <span class="text">Dans ce cas, la pièce deviendra invalide.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Plage de localisation d'utilisation des pièces</span>
            <span class="text">Il n’y a pas de limite supérieure pour les pièces.</span>
            <span class="text">Les pièces (devise sur ce site) peuvent être utilisées dans le compte enregistré.</span>
            <span class="text">De plus, le transfert de comptes et le transfert de pièces sont interdits.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Précautions d'emploi</span>
            <span class="text">Les pièces (monnaie sur ce site) ne peuvent pas être remboursées.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Comment vérifier les pièces que vous possédez</span>
            <span class="text">Vous pouvez le vérifier sur l'écran de ce site.</span>
            <span class="text">S'il y a un mouvement dans les pièces que vous possédez, le nombre changera automatiquement.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Coordonnées</span>
            <span class="text">Veuillez nous contacter ici.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">conditions de service</span>
            <span class="text">Veuillez vérifier les conditions d'utilisation de ce site.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'FundSettlement',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.fund-settlement{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .fund-settlement-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .left {
    text-align: left!important;
  }
}
</style>
